import { SVGProps } from 'react';

const Mucic = ({ props, size = 64 }: { props?: SVGProps<SVGSVGElement>; fill?: string; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#29236C" rx="32" />
    <path
      fill="#fff"
      d="m31.83 13.355.036-.02v.041l10.258 5.761.019.011v.002l5.777 3.246.04-.027v.048l.035.021-.036.024v19.095l.041.024-.04.023v.042l-.038-.021-15.728 8.902-.155.086v.002l-.003.001v.04l-.036-.02-.037.021-.018.01-.017-.01-4.339-2.472-.02-.01-.02-.011v-.048l-11.472-6.491-.036.021v-.042L16 41.581l.04-.023V22.462l-.035-.024.036-.02v-.049l.038.027 5.871-3.369.02-.01 9.822-5.64-.001-.043.039.02Zm.206 20.069v.05L32 33.448l-.036.025v-.05l-10.281-7.077v12.017l.076.055 5.79 3.357v-6.073l.058.043L32 38.987l4.396-3.242.058-.043v5.973l5.862-3.314V26.346l-10.281 7.078Zm-5.04-10.845L32 26.128l5.035-3.342.128-.093L32 19.083l-5.004 3.496Z"
    />
  </svg>
);

export default Mucic;
